import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate} from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient} from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';


function FamilyInfoUpdate() {

    const { menu, toggleMobileMenu } = useAppLayout();
    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [selectedCountry, setSelectedCountry] = useState("");
const [selectedTribe, setSelectedTribe] = useState("");
const [selectedSubTribe, setSelectedSubTribe] = useState("");
const [selectedGroup, setSelectedGroup] = useState("");
const [selectedClan, setSelectedClan] = useState("");
const [selectedTotem, setSelectedTotem] = useState("");
const [familyName, setFamilyName] = useState("");

  // Countries
  const { data: countries = [], isLoading: countryLoading } = useQuery({
    queryKey: ["countries"],
    queryFn: () =>
      axios.get(`${API_URL}/register-countries-api`, { withCredentials: true })
        .then(res => {
          if (Array.isArray(res.data)) return res.data;
          throw new Error("No countries found");
        }),
  });
  
  // Tribes - only fetch if a country is selected
  const { data: tribes = [], isLoading: tribeLoading } = useQuery({
    queryKey: ['tribes', selectedCountry], // <- include selectedCountry in key
    queryFn: () =>
      axios
        .get(`${API_URL}/reg-signup-tribes-api`, {
          params: { country_id: selectedCountry },
          withCredentials: true,
        })
        .then(res => {
          if (res.data.Status === "Success") return res.data.tribes;
          throw new Error("No tribes found");
        }),
    enabled: !!selectedCountry, // <- only run when a country is picked
  });


  //subtribes


  const { data: subtribes = [], isLoading: subtribeLoading } = useQuery({
    queryKey: ['subtribes', selectedCountry, selectedTribe],
    queryFn: () =>
      axios.get(`${API_URL}/reg-signup-subtribes-api`, {
        params: { country_id: selectedCountry, tribe_id: selectedTribe },
        withCredentials: true,
      }).then(res => {
        if (res.data.Status === "Success") return res.data.subtribes;
        throw new Error("No subtribes found");
      }),
    enabled: !!selectedCountry && !!selectedTribe, // only fetch when both selected
  });


  
// sub-Groups
const { data: groups = [], isLoading: groupLoading } = useQuery({
    queryKey: ['groups', selectedCountry, selectedTribe, selectedSubTribe],
    queryFn: () =>
      axios.get(`${API_URL}/reg-signup-group-api`, {
        params: {
          country_id: selectedCountry,
          tribe_id: selectedTribe,
          subtribe_id: selectedSubTribe
        },
        withCredentials: true,
      }).then(res => {
        if (res.data.Status === "Success") return res.data.groups;
        throw new Error("No subgroups found");
      }),
    enabled: !!selectedCountry && !!selectedTribe && !!selectedSubTribe, // Only run when all are chosen
  });

 
//   navigate(res.data.redirect || "/family-info-update-clan");
  
const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmit = (e) => {
  e.preventDefault();

  // ✅ Required field validation
  if (!selectedCountry) {
    toast.error("Please select a country");
    return;
  }
  if (!selectedTribe) {
    toast.error("Please select a tribe");
    return;
  }
  

  setIsSubmitting(true);

  axios
    .put(
      `${API_URL}/update-family-info-api`,
      {
        country_id: selectedCountry,
        tribe_id: selectedTribe,
        subtribe_id: selectedSubTribe || null,
        subgroup_id: selectedGroup || null,
        
      },
      { withCredentials: true }
    )
    .then((res) => {
      if (res.data.Status === "Success") {
        toast.success("Family info updated successfully", { autoClose: 3000 });

      
        //queryClient.invalidateQueries(['familyName']);
      //queryClient.setQueryData(['familyName'], familyName.trim());

        // Navigate to home or redirect from backend

        navigate("/family-info-update-clan");
     

      } else {
        toast.error(res.data.Message);
      }
    })
    .catch(() => toast.error("An error occurred. Please try again."))
    .finally(() => setIsSubmitting(false));
};
  
   

    return (
            <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
            <ToastContainer />

                <div className="page-wrapper">
                    <div className="content container-fluid">

                    
                    
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 col-xl-7">
              {/* ✅ remove overflow-hidden (it can clip dropdowns) */}
              <div className="card shadow-sm border-0 rounded-4">
                {/* ✅ smaller header */}
                <div
                  className="px-3 py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(116,186,84,0.18), rgba(44,83,61,0.06))",
                    borderBottom: "1px solid rgba(44,83,61,0.12)",
                  }}
                >
                  <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
                    <div>
                      <h5 className="mb-1 fw-bold">Update Your Family Info</h5>
                    </div>

                    <div className="text-end">
                      <div
                        className="badge px-3 py-2 rounded-pill"
                        style={{
                          background: "rgba(116,186,84,0.18)",
                          color: "#2C533D",
                          border: "1px solid rgba(44,83,61,0.18)",
                        }}
                      >
                        Step 1 of 2
                      </div>
                    </div>
                  </div>

                  <div className="mt-2">
                    <div className="progress" style={{ height: 7, borderRadius: 999, background: "rgba(44,83,61,0.12)" }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "50%", background: "linear-gradient(90deg, #74BA54, #2C533D)" }}
                      />
                    </div>
                  </div>
                </div>

                {/* ✅ smaller body, extra bottom space so browser has room to open dropdown DOWN */}
                <div
                  className="card-body p-3 p-md-4"
                  style={{
                    paddingBottom: 28, // helps dropdown have space below
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    {/* ✅ tighter grid */}
                    <div className="row g-3">
                      {/* Country */}
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-semibold mb-1">
                          Country <span className="text-danger">*</span>
                        </label>
                        <div className="position-relative">
                          {/* ✅ smaller select */}
                          <select
                            className="form-select form-select-sm rounded-3"
                            value={selectedCountry}
                            onChange={(e) => {
                              setSelectedCountry(e.target.value);
                              setSelectedTribe("");
                              setSelectedSubTribe("");
                              setSelectedGroup("");
                            }}
                          >
                            <option value="">Select Country</option>
                            {countryLoading ? (
                              <option disabled>Loading countries...</option>
                            ) : (
                              countries.map((country) => (
                                <option key={country.id} value={country.id}>
                                  {country.country_name}
                                </option>
                              ))
                            )}
                          </select>
                        </div>
                      </div>

                      {/* Tribe */}
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-semibold mb-1">
                          Tribe <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select form-select-sm rounded-3"
                          value={selectedTribe}
                          onChange={(e) => {
                            setSelectedTribe(e.target.value);
                            setSelectedSubTribe("");
                            setSelectedGroup("");
                          }}
                          disabled={!selectedCountry}
                        >
                          <option value="">
                            {!selectedCountry ? "Select country first" : "Select Tribe"}
                          </option>
                          {tribeLoading ? (
                            <option disabled>Loading tribes...</option>
                          ) : (
                            tribes.map((tribe) => (
                              <option key={tribe.id} value={tribe.id}>
                                {tribe.tribe_name}
                              </option>
                            ))
                          )}
                        </select>
                      </div>

                      {/* Subtribe */}
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-semibold mb-1">Subtribe (optional)</label>
                        <select
                          className="form-select form-select-sm rounded-3"
                          value={selectedSubTribe}
                          onChange={(e) => {
                            setSelectedSubTribe(e.target.value);
                            setSelectedGroup("");
                          }}
                          disabled={!selectedCountry || !selectedTribe}
                        >
                          <option value="">
                            {!selectedTribe ? "Select tribe first" : "Select Subtribe"}
                          </option>
                          <option value="0">No Subtribe</option>
                          {subtribeLoading ? (
                            <option disabled>Loading subtribes...</option>
                          ) : (
                            subtribes.map((sub) => (
                              <option key={sub.id} value={sub.id}>
                                {sub.name}
                              </option>
                            ))
                          )}
                        </select>
                      </div>

                      {/* Subgroup */}
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-semibold mb-1">Subgroup (optional)</label>
                        <select
                          className="form-select form-select-sm rounded-3"
                          value={selectedGroup}
                          onChange={(e) => setSelectedGroup(e.target.value)}
                          disabled={!selectedCountry || !selectedTribe || !selectedSubTribe}
                        >
                          <option value="">
                            {!selectedSubTribe ? "Select subtribe first" : "Select Subgroup"}
                          </option>
                          <option value="0">No Subgroup</option>
                          {groupLoading ? (
                            <option disabled>Loading subgroups...</option>
                          ) : (
                            groups.map((group) => (
                              <option key={group.id} value={group.id}>
                                {group.name}
                              </option>
                            ))
                          )}
                        </select>
                      </div>
                    </div>
                    

                    {/* ✅ tighter actions */}
                    <div className="d-flex justify-content-between mt-3">
                      <button
                        type="button"
                        className="btn btn-light border rounded-3 px-3 py-2"
                        onClick={() => navigate(-1)}
                        disabled={isSubmitting}
                      >
                        Back
                      </button>

                      <button
                        type="submit"
                        className="btn rounded-3 px-3 py-2 d-inline-flex align-items-center justify-content-center"
                        disabled={isSubmitting}
                        style={{
                          minWidth: 120,
                          background: "linear-gradient(135deg, #74BA54, #2C533D)",
                          border: "none",
                          color: "#fff",
                        }}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            />
                            Updating...
                          </>
                        ) : (
                          "Next »"
                        )}
                      </button>
                    </div>

                  </form>
                </div>
              </div>







              <div style={{ height: 8 }} />
            </div>
          </div>
                    </div>
                </div>
            </div>
        
    );
}

export default FamilyInfoUpdate;
